export default "__VITE_ASSET__eb598ca2__"